import React, { ReactNode, useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import "./index.scss";

interface TabsNavigate {
  children: ReactNode[];
  tabs: string[];
}

export default function TabsNavigate({ children, tabs }: TabsNavigate) {
  const [value, setValue] = useState(0);

  function handleChange(event: any, newValue: any) {
    setValue(newValue);
  }
  return (
    <div>
      <AppBar className="tabsContainer" position="static" color="default">
        <Tabs
          value={value}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs?.map((tab) => {
            return <Tab label={tab} />;
          })}
        </Tabs>
      </AppBar>
      {children[value]}
    </div>
  );
}
